import React, { useState, useEffect } from "react";
import { injectModels } from "../../redux/injectModels";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";

const UpdateUser = ({ isOpen, id, closeModel, props }) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const number = /^\d{10}$/;
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [macAddress, setMacAddress] = useState("");
  const [profileImage, setProfileImage] = useState("");
  const [about, setAbout] = useState("");
  const [job, setJob] = useState("");
  const [address, setAddress] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [postalCode, setPostalCode] = useState("");

  const [usernameError, setUsernameError] = useState("");
  const [macAddressError, setMacAddressError] = useState("");
  const [profileImageError, setProfileImageError] = useState("");
  const [aboutError, setAboutError] = useState("");
  const [jobError, setJobError] = useState("");
  const [addressError, setAddressError] = useState("");
  const [phoneNumberError, setPhoneNumberError] = useState("");
  const [cityError, setCityError] = useState("");
  const [stateError, setStateError] = useState("");
  const [countryError, setCountryError] = useState("");
  const [postalCodeError, setPostalCodeError] = useState("");
  
  useEffect(() => {
    getUserswithEmail();
  }, []);
  const getUserswithEmail = async () => {
    props.application.setLoading(true);
    try {
      const res = await props.admin.getOneUser(id);
      if (res) {
        const details = res && res.user;
        setUsername(details.username);
        setEmail(details.email);
        setPassword(details);
        setMacAddress(details.mac_address);
        setProfileImage(details.profile_image);
        setAbout(details.about);
        setJob(details.job);
        setAddress(details.address);
        setPhoneNumber(details.phone_number);
        setCity(details.city);
        setState(details.state);
        setCountry(details.country);
        setPostalCode(details.postal_code);
      }
      props.application.setLoading(false);
    } catch (error) {
      console.error("Failed to fetch users:", error);
      props.application.setLoading(false);
    }
  };

  const handleUsername = (e) => {
    const val = e.target.value;
    if (val === "") {
      setUsernameError("Username is required!");
    } else {
      setUsernameError("");
    }
    setUsername(val);
  };
  const handleMacAddress = (e) => {
    const val = e.target.value;
    if (val === "") {
      setMacAddress("IP Address is required!");
    } else {
      setMacAddressError("");
    }
    setMacAddress(val);
  };

  const handleAbout = (e) => {
    const val = e.target.value;
    if (val === "") {
      setAbout("About us is required!");
    } else {
      setAboutError("");
    }
    setAbout(val);
  };

  const handleJob = (e) => {
    const val = e.target.value;
    if (val === "") {
      setJob("Job Name is required!");
    } else {
      setJobError("");
    }
    setJob(val);
  };
  const handleAddress = (e) => {
    const val = e.target.value;
    if (val === "") {
      setAddress("Address is required!");
    } else {
      setAddressError("");
    }
    setAddress(val);
  };

  const handlePhoneNumber = (e) => {
    e.preventDefault();
    let inputValue = e.target.value;
    if (inputValue.length < 6 || inputValue.length > 13) {
      setPhoneNumberError("Enter a valid Mobile Number ");
    } else if (
      number.test(/^(\+\d{1,3}[- ]?)?\d{10}$/) &&
      !number.match(/0{5,}/)
    ) {
      setPhoneNumberError("Enter a valid mobile number");
    } else {
      setPhoneNumberError("");
    }
    setPhoneNumber(inputValue);
  };

  const handleCity = async (e) => {
    const val = e.target.value;
    if (val === "") {
      setCity("City is required!");
    } else {
      setCityError("");
    }
    setCity(val);
  };
  const handleState = (e) => {
    const val = e.target.value;
    if (val === "") {
      setState("State is required!");
    } else {
      setStateError("");
    }
    setState(val);
  };
  const handleCountry = (e) => {
    const val = e.target.value;
    if (val === "") {
      setCountry("Country is required!");
    } else {
      setCountryError("");
    }
    setCountry(val);
  };
  const handlePostalCode = (e) => {
    const val = e.target.value;
    if (val === "") {
      setPostalCode("Post code is required!");
    } else {
      setPostalCodeError("");
    }
    setPostalCode(val);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let error = false;

    if (username.trim() === "") {
      error = true;
      setUsernameError("Username is required!");
    } else {
      setUsernameError("");
    }
    if (macAddress === "") {
      error = true;
      setMacAddressError("IP Address is required!");
    } else {
      setMacAddressError("");
    }

    if (profileImage === "") {
      error = true;
      setProfileImageError("Profile Image is required!");
    } else {
      setProfileImageError("");
    }

    if (about === "") {
      error = true;
      setAboutError("About Us is required!");
    } else {
      setAboutError("");
    }
    if (job === "") {
      error = true;
      setJobError("Job is required!");
    } else {
      setJobError("");
    }
    if (address === "") {
      error = true;
      setAddressError("Address is required!");
    } else {
      setAddressError("");
    }
    if (phoneNumber.length < 6 || phoneNumber.length > 13) {
      error = true;
      setPhoneNumberError("Phone Number is required");
    } else if (
      number.test(/^(\+\d{1,3}[- ]?)?\d{10}$/) &&
      !number.match(/0{5,}/)
    ) {
      error = true;
      setPhoneNumberError("Enter a Valid Mobile Number");
    } else {
      setPhoneNumber("");
    }
    if (city === "") {
      error = true;
      setCityError("City is required!");
    } else {
      setCityError("");
    }
    if (state === "") {
      error = true;
      setStateError("State is required!");
    } else {
      setStateError("");
    }
    if (country === "") {
      error = true;
      setCountryError("Country is required!");
    } else {
      setCountryError("");
    }
    if (postalCode === "") {
      error = true;
      setPostalCodeError("PostalCode is required!");
    } else {
      setPostalCodeError("");
    }

    if (!error) {
      try {
        let data = {
          profile_image: profileImage !== "" ? null : "",
          username: username,
          mac_address: macAddress,
          about: about,
          job: job,
          address: address,
          phone_number: phoneNumber,
          city: city,
          state: state,
          country: country,
          postal_code: postalCode,
        };

        const res = await props.admin.userUpdate(data, id);

        if (res.success === true) {
          props.application.setLoading(false);
          toast.dismiss();
          toast.success(res.message, {
            position: toast.POSITION.TOP_CENTER,
          });
          getUserswithEmail();
          closeModel();
        } else {
          toast.dismiss();
          toast.error(res.message, {
            position: toast.POSITION.TOP_CENTER,
          });
          props.application.setLoading(false);
        }
      } catch (err) {
        console.log(err);
        props.application.setLoading(false);
        toast.dismiss();
        toast.error("Something went wrong!", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    }
  };

  return (
    <Modal
      show={isOpen}
      onHide={closeModel}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Update User</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: "20px" }}>
            <div className="row">
              <div className="col-md-6  users">
                <label htmlFor="username">Username</label>
                <input
                  type="text"
                  className="form-control"
                  id="username"
                  value={username}
                  onChange={handleUsername}
                  maxLength={20}
                />
                {usernameError && (
                  <div className="text-danger">{usernameError}</div>
                )}
              </div>

              <div className="col-md-6  users">
                <label htmlFor="macAddress">Mac Address</label>
                <input
                  type="text"
                  className="form-control"
                  id="macAddress"
                  value={macAddress}
                  onChange={handleMacAddress}
                  maxLength={90}
                />
                {macAddressError && (
                  <div className="text-danger">{macAddressError}</div>
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-md-6  users">
                <label htmlFor="about">About</label>
                <input
                  type="text"
                  className="form-control"
                  id="about"
                  value={about}
                  onChange={handleAbout}
                />
                {aboutError && <div className="text-danger">{aboutError}</div>}
              </div>
              <div className="col-md-6  users">
                <label htmlFor="job">Job</label>
                <input
                  type="text"
                  className="form-control"
                  id="job"
                  value={job}
                  onChange={handleJob}
                  maxLength={40}
                />
                {jobError && <div className="text-danger">{jobError}</div>}
              </div>
            </div>
            <div className="row">
              <div className="col-md-6  users">
                <label htmlFor="address">Address</label>
                <input
                  type="text"
                  className="form-control"
                  id="address"
                  value={address}
                  onChange={handleAddress}
                  maxLength={250}
                />
                {addressError && (
                  <div className="text-danger">{addressError}</div>
                )}
              </div>
              <div className="col-md-6 users">
                <label htmlFor="pnumber">Phone Number</label>
                <input
                  type="Number"
                  className="form-control"
                  id="pnumber"
                  value={phoneNumber}
                  onChange={handlePhoneNumber}
                  maxLength={12}
                />
                {phoneNumberError && (
                  <div className="text-danger">{phoneNumberError}</div>
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-md-6  users">
                <label htmlFor="city">City</label>
                <input
                  type="text"
                  className="form-control"
                  id="city"
                  value={city}
                  onChange={handleCity}
                  maxLength={40}
                />
                {cityError && <div className="text-danger">{cityError}</div>}
              </div>
              <div className="col-md-6 users">
                <label htmlFor="state">State</label>
                <input
                  type="text"
                  className="form-control"
                  id="state"
                  value={state}
                  onChange={handleState}
                  maxLength={40}
                />
                {stateError && <div className="text-danger">{stateError}</div>}
              </div>
            </div>
            <div className="row">
              <div className="col-md-6  users">
                <label htmlFor="country">Country</label>
                <input
                  type="text"
                  className="form-control"
                  id="country"
                  value={country}
                  onChange={handleCountry}
                  maxLength={40}
                />
                {countryError && (
                  <div className="text-danger">{countryError}</div>
                )}
              </div>
              <div className="col-md-6 users">
                <label htmlFor="postalCode">Postal Code</label>
                <input
                  type="text"
                  className="form-control"
                  id="postalCode"
                  value={postalCode}
                  onChange={handlePostalCode}
                  maxLength={8}
                />
                {postalCodeError && (
                  <div className="text-danger">{postalCodeError}</div>
                )}
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
            }}
          >
            <button className="btn btn-secondary" onClick={closeModel}>
              Back
            </button>
            <button className="btn btn-primary" onClick={handleSubmit}>
              Update User
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default injectModels(["admin", "application"])(UpdateUser);
